module.exports = __webpack_public_path__ + "media/images/lp-treemap-07ca270a2ff8775914c47a0ba56b7b54.svg";